import { useUpdateOrgMutation } from "@hooks";
import { useEffect, useState } from "react";
import { useSnackbar } from "src/components/Snackbar";

export type UpdateOrgCompanyDescriptionProps = {
  updateOrgCompanyDescriptionResponse: UpdateOrgCompanyDescriptionResponse;
};

export type UpdateOrgCompanyDescriptionResponse = {
  setCompanyDescription: (companyDescription: string) => void;
  isCompanyDescriptionDirty: boolean;
  setOpenChangeOrgCompanyDescriptionModal: (open: boolean) => void;
  openChangeOrgCompanyDescriptionModal: boolean;
  handleCloseChangeOrgCompanyDescriptionModal: () => void;
  handleUpdateOrgCompanyDescription: () => void;
  oldCompanyDescription: string;
};

export default function useUpdateOrgCompanyDescription({
  orgId,
  oldCompanyDescription,
}: {
  orgId: string;
  oldCompanyDescription: string;
}): UpdateOrgCompanyDescriptionProps {
  const [companyDescription, setCompanyDescription] = useState(
    oldCompanyDescription
  );
  const [
    openChangeOrgCompanyDescriptionModal,
    setOpenChangeOrgCompanyDescriptionModal,
  ] = useState(false);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    setCompanyDescription(oldCompanyDescription);
  }, [oldCompanyDescription]);

  const updateOrgMutation = useUpdateOrgMutation(orgId);

  const handleCloseChangeOrgCompanyDescriptionModal = () => {
    setCompanyDescription(oldCompanyDescription);
    setOpenChangeOrgCompanyDescriptionModal(false);
  };

  const handleUpdateOrgCompanyDescription = async () => {
    const trimmedCompanyDescription = companyDescription.trim();

    try {
      await updateOrgMutation.mutateAsync({
        companyDescription: trimmedCompanyDescription || null,
      });
      setOpenChangeOrgCompanyDescriptionModal(false);
    } catch {
      showSnackbar("Failed to update company description");
    }
  };

  return {
    updateOrgCompanyDescriptionResponse: {
      setCompanyDescription,
      isCompanyDescriptionDirty:
        companyDescription.trim() !== oldCompanyDescription.trim(),
      setOpenChangeOrgCompanyDescriptionModal,
      openChangeOrgCompanyDescriptionModal,
      handleCloseChangeOrgCompanyDescriptionModal,
      handleUpdateOrgCompanyDescription,
      oldCompanyDescription,
    },
  };
}
